import { DRAWER_TOGGLE } from '../constants/ActionTypes'

export const acDrawerToggle = () => ({ type: DRAWER_TOGGLE })